<template>
  <v-container>
    <v-card style="padding: 10px; border-radius: 3px" elevation="1">
      <v-toolbar flat color="white">
        <v-text-field
          v-model="search"
          @input="searchContents"
          prepend-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

        <v-menu
          :nudge-bottom="14"
          offset-y
          origin="center center"
          class="elelvation-1"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon flat>
              <v-icon medium class="black--text">more_vert</v-icon>
            </v-btn>
          </template>
          <!-- <v-card class="elevation-0">

                    <v-card-text class="pa-0"> -->
          <v-list class="pa-0">
            <v-list-item
              v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
              avatar
              to="/bulklocation"
            >
              <v-list-item-avatar>
                <v-icon medium dark color="primary">import_export</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-sub-title>Batch import</v-list-item-sub-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <!-- <v-list-item avatar @click="handleClick">
                <v-list-item-avatar>
                  <v-icon medium dark color="primary">cloud_download</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-sub-title>
                    <download-csv :data="locationExportToCSV" name="LocationDataCSV.csv"
                      >Export
                    </download-csv>
                  </v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item> -->

            <v-list-item @click="exportInCSV" style="cursor: pointer">
              <v-list-item-avatar>
                <v-icon medium dark color="primary">get_app</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                Export
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item
              @click="selectAll"
              v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
              avatar
            >
              <v-list-item-avatar>
                <v-icon medium dark color="primary">check_box</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-sub-title>
                  Select all
                </v-list-item-sub-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item
              v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
              @click="bulkDeleteLocation"
              avatar
            >
              <v-list-item-avatar>
                <v-icon medium dark color="primary">delete_sweep</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-sub-title>
                  Batch Delete
                </v-list-item-sub-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-card>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 style="padding: 10px">
        <div v-if="locations.length > 0" style="border-radius: 2px; box-shadow: none;">
          <DisplayCard
            v-if="renderComponent"
            :renderData="locationContents"
            @deleteData="deleteItem"
            @editData="editItem"
            @selectDataIds="BulkDeleteIds"
            :selectAll="selectAllData"
          ></DisplayCard>
        </div>
        <div v-else align="center">
          <v-nodata
            :loading="loading.locationOption"
            :networkError="networkError.locationOption"
            @retryMethod="getLocationsData"
            title
            msg-details="You haven't added any location yet"
            icon="clip-education"
          ></v-nodata>
        </div>
      </v-flex>
    </v-layout>

    <!-- add location Dialog -->
    <v-dialog
      v-model="dialog"
      :fullscreen="$mq == 'mobile' ? true : false"
      max-width="500px"
      persistent
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="canSee('modifyLocation')"
          v-on="on"
          color="primary"
          dark
          fixed
          right
          bottom
          fab
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <v-card elevation="2" style="border-radius: 5px;">
        <v-card-title class="primary">
          <h4 class="reg__heading">{{ formTitle }}</h4>
          <v-spacer></v-spacer>
          <v-btn v-if="$mq == 'mobile'" @click="dialog = false" icon fab small dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text style="padding: 5px">
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <GmapMap
                :center="editedItem.coordinates"
                :zoom="14"
                map-type-id="terrain"
                style="min-width: 200px; min-height: 400px;width:100%"
              >
                <GmapMarker
                  :position="editedItem.coordinates"
                  :clickable="true"
                  :draggable="true"
                  @dragend="updateLoc"
                  :icon="{
                    url: require('@/assets/ft.png'),
                    size: { width: 45, height: 45, f: 'px', b: 'px' },
                    scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }
                  }"
                />
                <gmap-circle
                  :center="editedItem.coordinates"
                  :radius="editedItem.radius"
                ></gmap-circle>
              </GmapMap>
              <div style="text-align: right">
                <v-btn
                  @click="geoCurrentLocation"
                  fab
                  small
                  color="primary"
                  style="margin-top: -110px; margin-right: 60px"
                  class="white--text"
                  ><v-icon>my_location</v-icon>
                </v-btn>
              </div>
            </v-flex>

            <!-- <v-flex xs12 sm12 md12 style="text-align: center">
                <div>
                  <v-btn color="green" class="white--text" @click="geoCurrentLocation"
                    >Recenter</v-btn
                  >
                </div>
              </v-flex> -->

            <v-flex xs12 sm12 md12 class="reg__custom__flex">
              <div style="padding: 10px">
                <gmap-autocomplete
                  :placeholder="placeholder"
                  :value="editedItem.address"
                  @place_changed="setPlace"
                  :select-first-on-enter="true"
                  class="input"
                ></gmap-autocomplete>
                <span class="highlight"></span>
                <span class="bar"></span>
              </div>
            </v-flex>

            <v-flex xs12 sm12 md12 class="reg__custom__flex">
              <v-text-field
                ref="locationNameRules"
                v-model="editedItem.name"
                :rules="locationNameRules"
                label="Location name"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6 md6 class="reg__custom__flex">
              <v-text-field
                @input="updateLoc()"
                v-model="latLngBox.lat"
                :value="editedItem.coordinates.lat"
                label="Lat"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6 md6 class="reg__custom__flex">
              <v-text-field
                @input="updateLoc()"
                v-model="latLngBox.lng"
                :value="editedItem.coordinates.lng"
                label="long"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12 class="reg__custom__flex">
              <v-textarea v-model="editedItem.desc" label="Description"></v-textarea>
            </v-flex>

            <v-flex
              v-if="editedItem.code != ''"
              xs12
              sm12
              md12
              style="display:none;"
              class="reg__custom__flex"
            >
              <v-text-field v-model="editedItem.code" label="Location Code" disabled></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12 class="reg__custom__flex">
              <v-text-field
                v-model="editedItem.radius"
                @input="checkRadius"
                type="number"
                label="Radius"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12 class="reg__custom__flex">
              <v-layout row wrap>
                <v-flex xs10 sm10 md10 class="reg__custom__flex">
                  <v-autocomplete
                    v-model="editedItem.wifi"
                    :items="wifiList"
                    :return-object="true"
                    item-text="SSID"
                    label="Select Wifi"
                    clearable
                    chips
                  ></v-autocomplete>
                  <!-- <v-slide-x-reverse-transition
                        slot="append-outer"
                        mode="in"
                      >
                        <v-icon
                          key="icon-true"
                          color="success"
                          @click="updateWifi"
                          v-text="`network`"
                        ></v-icon>
                      </v-slide-x-reverse-transition> -->
                </v-flex>

                <v-flex xs2 sm2 md2 class="reg__custom__flex">
                  <v-btn
                    key="icon-true"
                    @click="updateWifi"
                    class="md-2"
                    style="background: transparent; border: none; box-shadow: none; margin-top: 8px"
                    fab
                    ><v-icon>network_wifi</v-icon>
                  </v-btn>
                </v-flex>
                <h2 style="font-size: 13px; font-weight: 500; color:#1a1a1a; margin-left: 10px">
                  Assigned Members
                </h2>

                <v-flex v-if="loader" xs12 sm12 md12 class="reg__custom__flex">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-flex>

                <v-flex
                  v-else-if="assignes.length > 0 && formTitle == 'Edit'"
                  xs12
                  sm12
                  md12
                  class="reg__custom__flex"
                  style="text-align: left !important"
                >
                  <v-chip
                    v-for="(user, index) in assignes"
                    :key="index"
                    class="ma-2"
                    color="primary"
                    text-color="white"
                    label
                  >
                    <v-avatar left color="#fafafa" style="color: #1a1a1a">
                      {{ user.firstName.substring(0, 1) }}
                    </v-avatar>
                    {{ user.email }}
                  </v-chip>
                </v-flex>

                <v-flex
                  v-else-if="formTitle == 'New' || (assignes.length < 1 && formTitle == 'Edit')"
                  xs12
                  sm12
                  md12
                  class="reg__custom__flex"
                  style="text-align: left !important"
                >
                  <v-alert border="left" colored-border elevation="2" dense color="orange">
                    <h4
                      style="font-size: 12px; letter-spacing: 0.5px; font-weight: 500; color: #1a1a1a"
                    >
                      Currently you dont have any members assigned to this location, please
                      <a href="/#/members">visit</a> the member's page to assign.
                    </h4>
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click.native="close"
            color="primary"
            text
            style="font-size: 14px; margin-top: 2px; letter-spacing: 1px;"
            >Cancel</v-btn
          >
          <v-btn
            v-if="formTitle == 'New' && canSee('modifyLocation')"
            :disabled="isClicked"
            :loading="isClicked"
            @click.native="save"
            color="primary"
            >Save</v-btn
          >
          <v-btn
            v-else-if="canSee('modifyLocation')"
            :disabled="isClicked"
            :loading="isClicked"
            @click.native="save"
            color="primary"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Not Needed!! just in case -->
    <v-dialog v-model="bulkAddDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Bulk Location Add</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-text-field
                  @click="pickFile"
                  v-model="csvName"
                  label="Select Csv File"
                  prepend-icon="attach_file"
                ></v-text-field>
                <input
                  id="csv_file"
                  ref="csv"
                  @change="loadCSV($event)"
                  type="file"
                  style="display: none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="csv_file"
                  class="form-control"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkAddDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn @click.native="bulkLocationAdd" color="primary">Add Locations</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- preloader -->
    <v-dialog v-model="preLoader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import blob from "blob";
import Papa from "papaparse";
import moment from "moment-timezone";
import wifi from "@/utilities/wifi";
import loc from "@/utilities/location";
import canSee from "@/utilities/canSee";
import VNodata from "@/components/Unavailable/nodata.vue";
import DisplayCard from "@/views/card.vue";

export default {
  components: { VNodata, DisplayCard },
  data: () => ({
    assignes: [],
    overlay: false,
    isClicked: false,
    locationExportToCSV: [],
    loader: false,
    preLoader: false,
    renderComponent: true,
    selectAllData: false,
    locationContents: [],
    selectedLocationsId: [],
    loading: {
      locationOption: true
    },
    networkError: {
      locationOption: false
    },
    locationNameRules: [
      v => /^[A-Za-z0-9][A-Za-z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Location name should be valid."
    ],
    dialog: false,
    bulkAddDialog: false,
    setLoading: true,
    search: "",
    isEditing: false,
    latLngBox: { lat: 22.22, lng: 88.22 },
    companyId: "",
    description: "",
    csvName: "",
    placeholder: "Address",
    selected: [],
    latLng: { lat: 22.2232, lng: 88.2232 },
    center: { lat: 22.2232, lng: 88.2232 },

    headers: [
      {
        text: "Name",
        align: "left",
        sortable: true,
        value: "name"
      },
      { text: "Address", align: "left", value: "address" },
      { text: "Radius", align: "left", value: "radius" },
      {
        text: "Edit",
        value: "name",
        align: "center",
        sortable: false
      },
      {
        text: "Delete",
        value: "name",
        align: "center",
        sortable: false
      }
    ],
    locations: [],
    // closeLoader : {},
    parse_header: [],
    parse_csv: [],
    sortOrders: {},
    sortKey: "",
    location_fields: {
      LocationName: "name",
      Address: "address",
      // 'Location Code':'code',
      Longitude: "longitude",
      Latitude: "latitude",
      Radius: "radius"
    },
    editedIndex: -1,
    editedItem: {
      name: "",
      address: "",
      code: "",
      desc: "",
      radius: 300,
      coordinates: {
        lat: 12.33,
        lng: 25.33
      },
      companyId: "",
      wifi: {}
    },
    defaultItem: {
      name: "",
      address: "",
      code: "",
      radius: 300,
      coordinates: {
        lat: 22.33,
        lng: 88.33
      },
      companyId: "",
      wifi: {}
    },
    wifiList: []
  }),
  computed: {
    searchContents() {
      const self = this;
      self.renderComponent = false;
      try {
        _.each(self.locationContents, f => {
          var re = new RegExp(self.search.toLowerCase(), "g");

          if (f.title.toLowerCase().match(re)) {
            f.visible = true;
          } else if ("desc" in f && f.desc.toLowerCase().match(re)) {
            f.visible = true;
          } else if (self.search == "") {
            f.visible = true;
          } else {
            f.visible = false;
          }
        });
      } catch (e) {
        console.log(e);
      }

      self.$nextTick(() => {
        self.renderComponent = true;
      });
    },
    formTitle() {
      return this.editedIndex === -1 ? "New" : "Edit";
    },
    pagination: {
      get: function() {
        if (this.$store.getters.pagination) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });
      }
    }
  },
  watch: {
    dialog(val) {
      if (val == true) {
        setTimeout(() => {
          this.setAddress();
        }, 2000);
      }

      val || this.close();
    }
  },
  created() {
    const self = this;
    self.getLocationsData();
    self.editedItem.companyId = self.$store.state.userDetails.companyId;
    self.defaultItem.companyId = self.$store.state.userDetails.companyId;
    self.updateWifi();
    self.geoCurrentLocation();
  },
  methods: {
    exportInCSV() {
      var csv = Papa.unparse(this.locationExportToCSV);

      if (this.$mq != "mobile") {
        try {
          var csvData = new Blob([csv], {
            type: "text/csv;charset=utf-8;"
          });

          var csvURL = null;
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, "download.csv");
          } else {
            csvURL = window.URL.createObjectURL(csvData);
          }

          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", "download.csv");
          tempLink.click();
        } catch (e) {
          console.log(e);
        }
      } else {
        window.resolveLocalFileSystemURL(cordova.file.cacheDirectory, function(dir) {
          console.log("dir", dir);
          dir.getFile(
            "export-locations-" + new Date().getTime() + ".csv",
            {
              create: true
            },
            function(file) {
              console.log("file", file);

              var logOb = file;

              function writeLog(str) {
                if (!logOb) return;
                logOb.createWriter(
                  function(fileWriter) {
                    fileWriter.seek(fileWriter.length);
                    var blob = new Blob([str], {
                      type: "text/csv;charset=utf-8;"
                    });
                    fileWriter.write(blob);
                    window.plugins.socialsharing.share(null, null, logOb.nativeURL, null);
                  },
                  () => {
                    this.$swal({ type: "error", text: "Something went wrong" });
                  }
                );
              }

              writeLog(csv);
            }
          );
        });
      }
    },

    selectAll() {
      this.renderComponent = false;
      this.selectAllData = true;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },

    updateLoc(newAddress) {
      const self = this;

      if (newAddress) {
        self.editedItem.coordinates = {
          lat: newAddress.latLng.lat(),
          lng: newAddress.latLng.lng()
        };

        self.latLngBox = {
          lat: newAddress.latLng.lat(),
          lng: newAddress.latLng.lng()
        };
      } else {
        self.editedItem.coordinates = {
          lat: Number(self.latLngBox.lat),
          lng: Number(self.latLngBox.lng)
        };
      }

      self.setAddress();
    },

    async geoCurrentLocation() {
      const self = this;

      // var position = await loc.get()

      // console.log("Position",position)

      //     self.editedItem.coordinates = {
      //       lat: position.coords.latitude,
      //       lng: position.coords.longitude
      //     };

      //     self.latLngBox = {
      //       lat: position.coords.latitude,
      //       lng: position.coords.longitude
      //     };

      //     self.setAddress();

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          self.editedItem.coordinates = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          self.latLngBox = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          self.setAddress();
        });
      }
    },

    setAddress() {
      const self = this;

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ location: self.editedItem.coordinates }, (results, status) => {
        console.log("results", results);

        console.log("status", status);

        if (status === "OK") {
          if (results[0]) {
            self.editedItem.address = results[0].formatted_address;
          } else {
            return null;
          }
        }
      });
    },

    canSee(what) {
      return canSee(this, what);
    },

    handleClick: e => {},

    async updateWifi() {
      if (this.$mq == "mobile") {
        try {
          this.wifiList = await wifi.list();
          console.log("Got wifi lis ", this.wifiList);
        } catch (e) {
          console.log(e);
        }
      } else {
        this.wifiList = [];
      }
    },
    pickFile() {
      this.$refs.csv.click();
    },
    bulkAddDialogPopup() {
      this.bulkAddDialog = true;
      this.parse_header = [];
      this.parse_csv = [];
      this.sortOrders = {};
      this.sortKey = "";
      this.csvName = "";
    },
    checkRadius() {
      this.editedItem.radius = Number(this.editedItem.radius);
    },
    csvJSON(csv) {
      const vm = this;
      const lines = csv.split("\n");
      const result = [];
      const headers = ["name", "address", "code", "lat", "lng", "radius"];

      vm.parse_header = headers;
      lines[0].split(",").forEach(key => {
        vm.sortOrders[key] = 1;
      });

      lines.map((line, indexLine) => {
        if (indexLine < 1) return; // Jump header line

        const obj = {};
        const currentline = line.split(",");

        headers.map((header, indexHeader) => {
          obj[header] = currentline[indexHeader];
        });

        result.push(obj);
      });

      result.pop(); // remove the last item because undefined values

      return result;
      // JavaScript object
    },
    loadCSV(e) {
      const vm = this;
      vm.parse_csv = [];
      vm.csvName = "";
      if (window.FileReader) {
        const reader = new FileReader();
        vm.csvName = e.target.files[0].name;
        reader.readAsText(e.target.files[0]);
        // Handle errors load
        reader.onload = function(event) {
          const csv = event.target.result;

          vm.parse_csv = vm.csvJSON(csv);

          e.target.value = null;
        };
        reader.onerror = function(evt) {
          if (evt.target.error.name == "NotReadableError") {
            alert("Can't read file !");
          }
        };
      } else {
        alert("FileReader are not supported in this browser.");
      }
    },
    bulkLocationAdd() {
      const data = this.parse_csv;

      const response = [];
      for (const n in data) {
        response.push(data[n]);
      }
      for (const m in response) {
        response[m].coordinates = {
          lat: Number(response[m].lat),
          lng: Number(response[m].lng)
        };
        response[m].companyId = this.$store.state.userDetails.companyId;
        delete response[m].lat;
        delete response[m].lng;
      }

      const postObj = {
        data: response
      };

      this.$http.post(`${this.$store.state.endpoint}Locations/bulk/create`, postObj).then(
        response => {
          this.bulkAddDialog = false;
          this.parse_header = [];
          this.parse_csv = [];
          this.sortOrders = {};
          this.sortKey = "";
          this.csvName = "";
          this.getLocationsData();
        },
        error => {
          // error callback
        }
      );
    },
    BulkDeleteIds(ids) {
      this.selectedLocationsId = ids;
    },
    bulkDeleteLocation() {
      const self = this;
      if (self.selectedLocationsId.length < 1) {
        self.$swal({ type: "warning", text: "There is no selected locations" });
        return;
      }
      self
        .$swal({
          text: `Do you want to continue?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "info",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes"
        })
        .then(result => {
          if (result.value) {
            self.preLoader = true;

            const postObj = {
              ids: self.selectedLocationsId
            };

            self.$http.post(`${self.$store.state.endpoint}Locations/bulk/delete`, postObj).then(
              response => {
                self.selectedLocationsId = [];
                self.getLocationsData();
                self.selectAllData = false;
              },
              err => {
                self.preLoader = false;
                if (err.body.error) {
                  self.$swal({ type: "error", text: err.body.error.message });
                  self.getLocationsData();
                  self.selectAllData = false;
                  return;
                }
                self.$swal({ type: "error", text: "Something went wrong. Try again later" });
              }
            );
          }
        });
      self.preLoader = false;
    },
    setPlace(place) {
      var self = this;

      self.editedItem.address = place.formatted_address;

      self.editedItem.coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      self.latLngBox = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },
    getLocationsData() {
      this.loading.locationsOption = true;

      // this.setLoading = true
      this.locations = [];
      this.selected = [];
      this.search = "";
      this.$store.dispatch("getLocations", { companyId: this.$store.state.userDetails.companyId });

      this.$http.get(`${this.$store.state.endpoint}Locations/get`).then(
        response => {
          this.loading.locationsOption = false;
          this.networkError.locationsOption = false;

          var response = response.body;
          this.locationContents = [];
          this.locationExportToCSV = [];
          for (const m in response) {
            var exportObj = {};

            response[m].latitude = response[m].coordinates.lat;
            response[m].longitude = response[m].coordinates.lng;

            response[m].title = response[m].name;
            response[m].visible = true;
            response[m].permissionType = "modifyLocation";
            response[m].contents = {
              Address: response[m].address,
              Radius: response[m].radius,
              Latitude: response[m].latitude,
              Longitude: response[m].longitude
            };

            this.locationContents.push(response[m]);

            exportObj.LocationName = response[m].name;
            exportObj.Address = response[m].address;
            exportObj.Latitude = response[m].latitude;
            exportObj.Longitude = response[m].longitude;
            exportObj.Radius = response[m].radius;
            if ("desc" in response[m]) {
              exportObj.Description = response[m].desc;
            } else {
              exportObj.Description = "";
            }

            this.locationExportToCSV.push(exportObj);
          }
          this.locations = response;
          this.loading.locationsOption = false;
          this.networkError.locationsOption = false;
          this.isClicked = false;
          this.preLoader = false;
        },
        error => {
          this.loading.locationsOption = false;
          this.preLoader = false;
          this.isClicked = false;
          this.networkError.locationsOption = true;
        }
      );
    },
    editItem(item) {
      this.editedIndex = this.locations.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.getAssignes(this.editedItem.id);

      this.latLngBox = {
        lat: item.coordinates.lat,
        lng: item.coordinates.lng
      };

      this.wifiList = [];
      if (item.wifi && Object.keys(item.wifi).length > 0) {
        this.wifiList = [item.wifi];
      }
      this.dialog = true;

      // this.getLocationsData();
    },
    deleteItem(item) {
      const self = this;
      self
        .$swal({
          text: `Do you want to delete ${item.name}?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "info",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes"
        })
        .then(result => {
          if (result.value) {
            self.preLoader = true;
            const itemObj = item.id;
            const index = self.locations.indexOf(item);
            // write item delete code
            self.$http.delete(`${self.$store.state.endpoint}Locations/${itemObj}`).then(
              response => {
                self.getLocationsData();
              },
              error => {
                // error callback
                self.preLoader = false;
                self.$swal({ type: "error", text: error.body.error.message });
              }
            );
          }
        });
      self.preLoader = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.isClicked = false;
    },

    // get assigned members
    getAssignes(id) {
      this.loader = true;
      this.assignes = [];
      this.$http
        .get(
          `${this.$store.state.endpoint}accounts?filter[where][companyId]=${this.$store.getters.userDetails.companyId}&filter[where][allowedLocations]=${id}`
        )
        .then(response => {
          this.loader = false;

          this.assignes = response.body;
        })
        .catch(err => {
          this.loader = false;
        });
    },

    save() {
      // this.overlay = true
      this.isClicked = true;
      this.preLoader = true;
      const itemObj = this.editedItem;

      console.log(itemObj);

      const self = this;

      if (itemObj.radius < 100) {
        self.$swal({
          type: "warning",
          text: "Minimum allowed radius is 100"
        });
        this.preLoader = false;
        this.isClicked = false;
        return;
      }
      if (itemObj.radius >= 20037510) {
        self.$swal({
          type: "warning",
          text: "Regular.li works only on earth. For now. Please reduce allowed radius."
        });
        this.preLoader = false;
        this.isClicked = false;
        return;
      }

      if (itemObj.coordinates.lat == "") {
        self.$swal({
          type: "error",
          text: "Please enter latitude"
        });
        this.preLoader = false;
        this.isClicked = false;
        return;
      }

      if (itemObj.coordinates.lng == "") {
        self.$swal({
          type: "error",
          text: "Please enter longitude"
        });
        this.preLoader = false;
        this.isClicked = false;
        return;
      }

      // if(itemObj.address == ""){

      //
      //   return

      // }

      if (this.editedIndex > -1) {
        // write item update code

        /* if (itemObj.code == ''){
            itemObj.code = itemObj.name.substring(0, 2) + itemObj.radius + Math.floor((Math.random() * 10000) + 1)

          }

        */

        if (typeof itemObj.wifi == "undefined") {
          itemObj.wifi = {};
        }

        const updateObj = {
          name: itemObj.name,
          address: itemObj.address,
          radius: itemObj.radius,
          code: itemObj.code,
          desc: itemObj.desc,
          coordinates: itemObj.coordinates,
          companyId: itemObj.companyId,
          wifi: itemObj.wifi
        };

        this.$http.patch(`${this.$store.state.endpoint}Locations/${itemObj.id}`, updateObj).then(
          response => {
            // success callback
            this.$refs.locationNameRules.resetValidation();
            this.getLocationsData();
            this.isClicked = false;
          },
          error => {
            // error callback
            this.isClicked = false;
            this.preLoader = false;
            self.$swal({
              type: "error",
              text: "Something went wrong"
            });
          }
        );
      } else {
        // write item add code

        if (this.editedItem.name == "") {
          const defaultName = "Default Location Name ";

          this.editedItem.name = defaultName.substring(0, 22) + Math.floor(Math.random() * 100 + 1);
        }

        const insertObj = {
          name: itemObj.name,
          address: itemObj.address,
          radius: itemObj.radius,
          desc: itemObj.desc,
          // code:itemObj.code,
          coordinates: itemObj.coordinates,
          companyId: itemObj.companyId,
          wifi: itemObj.wifi
        };

        // validation for location Name
        for (const x in this.locations) {
          if (insertObj.name.toLowerCase() == this.locations[x].name.toLowerCase()) {
            this.isClicked = false;
            this.preLoader = false;
            this.$swal({ type: "warning", text: "Use a different location name" });
            return;
          }
        }

        this.$http.post(`${this.$store.state.endpoint}Locations`, insertObj).then(
          response => {
            this.isClicked = false;
            this.$refs.locationNameRules.resetValidation();
            // success callback
            this.getLocationsData();
          },
          error => {
            // error callback
            this.isClicked = false;
            this.preLoader = false;
            self.$swal({
              type: "error",
              text: "Something went wrong"
            });
          }
        );
      }
      this.close();
    }
  }
};
</script>
<style>
.listHeightFix .v-list__item__title {
  height: 40px;
}

.group {
  position: relative;
}
input {
  font-size: 17px;

  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
input:focus {
  outline: none;
}

/* LABEL ======================================= */
label {
  color: #999;
  font-size: 17px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  top: 10px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
input:focus ~ label,
input:valid ~ label {
  top: -20px;
  font-size: 14px;
  color: #0000ff;
}

/* BOTTOM BARS ================================= */
.bar {
  position: relative;
  display: block;
  width: 100%;
}
.bar:before,
.bar:after {
  content: "";
  height: 1px;
  width: 0;
  bottom: 1px;
  position: absolute;
  background: #0000ff;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.bar:before {
  left: 50%;
}
.bar:after {
  right: 50%;
}

/* active state */
input:focus ~ .bar:before,
input:focus ~ .bar:after {
  width: 50%;
}

/* HIGHLIGHTER ================================== */
.highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from {
    background: #0000ff;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #0000ff;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #0000ff;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.pull-down-container {
  height: auto !important;
  max-height: auto !important;
  overflow-y: auto;
}
.pull-down-header {
  width: 100%;
  height: 0px;
  overflow: hidden;
  position: relative;
  background-color: #fafafa !important;
}
.pull-down-content {
  position: absolute;
  max-width: 90%;
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  height: 40px;
  color: #1a1a1a !important;
  text-align: center;
  border-left: 20px solid transparent;
  font-family: "noto-thin", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}
.pull-down-content--icon {
  float: left;
  height: 20px;
  width: 20px;
  margin-top: 10px;
  margin-left: -20px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfgCxECIiTd0MZWAAAC9UlEQVRo3u1YTWgTQRh908RAxYI/h1I9CIppslOK1lKIxIKClV568CBEoe2tVALSo9C7x9SLh94jxYOCl9YKerA1kNYqwm5iitIeqrUHq6RYSJOOF9HETHbnm12SHvLtbb5v3nvMzrz5YdCI7MlSAgM4Wtb0A/O+idAXOhajd1k+dHhZdEugPvzq7d2jorXQBbT2y+gB0d3aT0fTEIATGhkvBfgXsStN7PoX6yKgc4ONSSTssrHODTqaxiQEgI+nSlFxrAxm27egQ38AQnMEMsH9KygbAWy3vArn6ibAuiMewP9fY5HdNR7WRYB1WuQQkCQKLGisU9F0fCAipQcCiNDBNASwr/SMpwJCC0hLE+nQQn1GoIRBTGMNP8u+NUxjkJXoaM3Q8gHzOO5joNKIMI97/HtdBAif9QZ9kkTauESfBRqTMBuV0gN92SgdTUOA6KBnPBWAFArS9gJSdRFgrLMJFKuai2yCvhMcgO244aG1DDNDol0C9S38jL4M/dQOQGZIPJEKQ+YGnlLRdJZhOz3jqQBvoymgKaApoCmg4QJsNyPzJq5Kmg1crtHhNSxJ60v+WEuAYFZBZ7OqiqIRYKJW0uYXMIEZD+iBmdr0Dr8g21Z6h7Mu6T/5LoTytdO2kzCUFzGQnx4rYk/E7OgdV0HXEpt0w88mu5YcKpwgBLOe45om/wvjut3/VxgBgAkMY0uLfgvDTvRKRsQ3MQJHoKoQGOGbzmVKTsjnkCALSPA5lTLFY7kZQAo9BPoVRHhBpVD5XmCdEys4oli8w3qMVbVS5c3IWBVx1VoRV6Un3ozMJG4plD3it9UxSQKybaX3OONQ9Nl33t77KoN0Hgjl4WTNe4hR6MkHEp62t2Y2ydOqWH960ModrFnBel2OgK01K1mvawEA38SoxJoFRlWs1wMBAJ9lU1UjM8VndbA034iqrFnZej0SAGSC+2//WvNOy0XdJyrte0E498+aRbxBL2Rm0hSmMJNuMFyd+wPjhQ4gMO4G4zdBpNqIFsTL6gAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNi0xMS0xN1QwMjozNDozNiswMTowMGXkq+sAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTYtMTEtMTdUMDI6MzQ6MzYrMDE6MDAUuRNXAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==)
    no-repeat center center;
  background-size: 20px 20px;
}
.pull-down-content--icon.pull-down-refresh {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfgCxECLwPNdA1wAAAEz0lEQVRo3u1ZXUxcRRT+ZlgE2mabLiJgKGBKU3fvAkvdUEtSf6DW2miMRks1aoPEJqbV+EA1jSmJNDFNmtRqSxr/aLSxJlaTPphIRatGo9QC7eYyl4ctWG1KGlFToYVlXXZ8YFl2d2YW7mV30we+p5lzZs/3zblz586cJbCMy3mjL2IdalAInVwIf+H+zkoUYpWe1eJjrIkxcH40sNs7niEBxmP8JLIEc//EOrMSqBV6vZC/J6EH3Hn7zcayJIC241aFa5dxT9oF9GTjYaWT8EfTLiDHiZwk7pq0C6DupG73PMNEYFM5/AWBDXQtSjmjvdk/rp6c9YSHk6oeTokA1hR8iy4HAAKOoKFvr+yZ8YUu3JIs4nlzAqSTMU6gA8tjDC7azZ6f6dRcg6EOyH9esADWxJ8SjFk4zCqivZfAFfF6R46ZEyDshP6CoD9u9rM4ozVERR7GLsmISdylMWFCm8lOno8u+/6VE+JPhDUQ2EDl9MB9bJl2fbq5ZPc4x64E+VdIk0ukfwInOQCsH63jm4iQOeER0LXKbFF4Zpp3BLSX8QB0hCOGMfJR0O3qkvyqNdra2L9+HhlAKdSI82nfosq3lFZnFXLdNUhUq6I8ZgblEJaoIIAz9QeSCwmuvoG5Vv1ZbIy0wuScLK2Jhl5lqMAIg3m8gpFIq83lF93iW5AT7INLFom0u2Qrf074Cya3kvzwN5XSXEnyrXtpt+RrPxSqqr5hRUBySDaiyh7sQOK5Zog8mQ56xVasdaAaZ6KvWIC0h6pcfemgT3omZMvgQSlnI+z+UHrIF3Ezgjm4pXOydUQXIfOgDV4UYxw+fsz9foYFsD14A9kx9k7bs2v+ypgAYxv/VHB86XokPZSsntTxcdrl1CMCfLfZDORLRjZrHakm51nGJ2gEAITwmnYQoIBti5QeeC4Ns2+J0AM2HNDrprdi1V3Gwy1f3lWgT8d2aOO0gCLFaHtvXqoF8HiuIoACRFeMHjRfbpgT5xN7FMBZxeBfU04P+jpmP2y/Z7UDFHB14bRk7PWpvakX4OxFPXRw/IfT5N47xyL7gK/E5oMjfih5wfVB6gVMw2/H5Mx1N7LOfSXZH/JN0RHDaNY600WfMNHZJqsnXu4mw7wv+HXNtczQL2IRNwGSfG6Mu3k1LyEDU91VQxkXYBTzDmyOdEJ48899C7kbsAo47LqsPqIQwBzQcXuc6TOtEZbQ/yB5F2UAQjhkbxVFSM/A5EgCPbCVPWORvhNlAAAbWkZPzCsDA/lh2XH0nFZrXgC7FKGfwRbtqzkzwOVVoqqebJgEq0igBxoSx8gErJBGy1mxxHQCHHNbJAKIvNg6tOpfs/x2HYnvjnDJlwhwXsSgJC+Kz7NRzGp+y5X7Vk7gUJzhSu7x+WSA02ahFPtHzh5xpP44u8yH0Tc+xk4ZxdIctOLULD1vFLOo2IjYDhzE0mjXT7aJFZL+vaQtpvs39TovSWM9hAY40Jd7XPYQlVuxvoq2EC8vQz9+mDggno91L/0lvspIvnfWK8uVSli+ehhH+E7BuFq7aDaO5WoA90iMHpNBFiKAyIp2Fgp51jMglu242b9rFiQAb+OfBP6j2tUMCtCuhrdjLMbw09SrVuIs6AI+UB7eh1oUQSefO98hYSsx/gdmXWWZ4qY5wwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNi0xMS0xN1QwMjo0NzowMyswMTowMHtfLS8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTYtMTEtMTdUMDI6NDc6MDMrMDE6MDAKApWTAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==)
    no-repeat center center;
  background-size: 20px 20px;
  -webkit-animation: rotate 2s infinite;
  animation: rotate 2s infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
}
.pull-down-content--icon.pull-down-error {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfgCxIBFzacq2QfAAAEO0lEQVRo3u2ZXWwUVRzFf/fuLNBWl0KxYmhxFaF1l1oxxZjIA5G0QU0TjAZMDEappNFEMagPavxqBPzAtDX6opGYaDTwYGKAmBANwQjyUGm2ZbbgVqMVH3xRrKYk/ZjrA+3uznZ39t673RoTz1Pv9P8/58yZmTtz78L/+Jch7NqUcNvEw9xEFPiJAT6MHRPevBkYbJEf05Bz8Ae5/cZvzbmkeYvbKU/OkodV3gn3iXlIIHm3Oly4y7u36bOyGhiKemdYElAwKlpiKRNGw0vgvR0oDxH1rhmjkYHBNtqLFrWeLV6TBYNLcNypTRDTKBwmHh8vQwK1j2rJww1iVxkSGKrxUkWufwaj3pqm3+Y4gakubXmIyD1znMBQk9dPSNsAeGJ97MwcJuD1GMmDVL2ahTpFyXu4w0geYENym06ZxiVILRxPcr2xARiJNNZfmoMExndbycPK0WfmIIHkNep7rrAyAGOTDc0XSk1gX0F5xX7Wilaeo9CnSGX4jRITcG/ldIEaRWv8q+mUOtT7hZi825tOWSegBL0FLfbNyEPsAw4X4gj1qsCTDDSQfIDbCv7zqM9qX8GTaEk+ZGkgUcVrAZ0/+0Z/B1TuPXellQHnWVYE0NZkD0R1QOVy73kLA0NRniIIPgMEGUA9ObjK2ID3JosCDSz1jYLflAvlfkMDgxu5L5AStVg/AWCLu8nAgJKypwghImJkAHpU3vdpXgPJnTQXJfQZEIuL1q8d6tQ00F/Nq0XpwCepIsUbVNdAnjslj4HwSyzTMOCXLJ4A1IRemX1w1jQ50BgaIKxB90c86zlwJ7W+mCZpjieLJBDq1pL3JZCo0vxgc0R37qEcA8m72KxFBaFE1cyfYY074DJUW+66yWegL6y6damyZSd17oBpiLfcBQUNVDzOGn2qjGxIOwFgNb5dhCwDqat40YAoS9arNOnjhURtXgMTe7QepjQyc6GsMDIQCWWtm9IG3JtVhxENKrNUjZt1ih3uutkJ9BrvF+26PLsryWOGnZL0uml6InK3ctCQBOA07wmpOllv0bstfiht4JeK0SGutSApBdPrJgnw59PzLp9eNwlI1DnnMXuQpiE+VUdAtYv7rSyMTTY0X3DA2WsnT0fsAACfnP1GvGPRX+ns5UHhLmdE8/Xjx4n4xszA/Y5bLDgmWCnZYSWP+No3PGXDQVg8IrnTqhVV7RstsmTZLKm3a6U98zpORYTuSzwX9ZKrLVujzkf91QDnl40fos6SpVa4P3KdZTP8zklgg8EGXi5SDsMlGFiqsXccjHNSfVEiRWk4IvqrF/xqORGVjouXVsh1Fym6j1MuqK6WMQFKJo+xqXQ6Y3we3wIShMdWvpx/+dB2SH+QqJD7stg9b/fCKPtirwuVZQBgYImzU7WxmjqbH/O0MMUIw+KoPND418yhPFtox52oUx796ISYKtOp/YfxD78X/HbumAqxAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE2LTExLTE4VDAxOjIzOjU0KzAxOjAwJGZ8CAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNi0xMS0xOFQwMToyMzo1NCswMTowMFU7xLQAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC)
    no-repeat center center;
  background-size: 20px 20px;
}
.pull-down-content--label {
  float: left;
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
  margin-top: 10px;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
